import { useRef } from "react";
import { motion } from "framer-motion";
import HeroSection from "./sections/HeroSection";
import ProblemSection from "./sections/ProblemSection";
import FeaturesSection from "./sections/FeaturesSection";
import SocialProofSection from "./sections/SocialProofSection";
import CheckoutSection from "./sections/CheckoutSection";
import FAQSection from "./sections/FAQSection";
import FooterSection from "./sections/FooterSection";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

export default function LandingPage() {
  const checkoutRef = useRef(null);

  const scrollToCheckout = () => {
    checkoutRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#1e1e1f" }}>
      <motion.div initial="hidden" animate="visible" variants={fadeUp}>
        <HeroSection onCTA={scrollToCheckout} />
      </motion.div>

      <AnimatedSection>
        <ProblemSection />
      </AnimatedSection>

      <AnimatedSection>
        <FeaturesSection />
      </AnimatedSection>

      <AnimatedSection>
        <SocialProofSection />
      </AnimatedSection>

      <div ref={checkoutRef}>
        <AnimatedSection>
          <CheckoutSection />
        </AnimatedSection>
      </div>

      <AnimatedSection>
        <FAQSection />
      </AnimatedSection>

      <FooterSection />
    </div>
  );
}

function AnimatedSection({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
